"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SquareBorderButton = _interopRequireDefault(require("../../Button/SquareBorderButton"));

var _Footer = _interopRequireDefault(require("./Footer.style"));

var Footer = function Footer(_ref) {
  var id = _ref.id,
      buttons = _ref.buttons;
  return _react.default.createElement(_Footer.default, null, buttons.map(function (_ref2) {
    var label = _ref2.label,
        _onClick = _ref2.onClick;
    return _react.default.createElement(_SquareBorderButton.default, {
      key: label,
      onClick: function onClick() {
        return _onClick(id);
      },
      className: "SnackbarFooter__button",
      text: label,
      size: "medium"
    });
  }));
};

Footer.propTypes = {
  id: _propTypes.default.string.isRequired,
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    onClick: _propTypes.default.func.isRequired
  }))
};
Footer.defaultProps = {
  buttons: []
};
var _default = Footer;
exports.default = _default;